// ==============================================
// ==================Import======================
// ==============================================

// ==================Style&IMG===================
import './style.scss';

// =================Material UI==================
import {
  Backdrop,
  Box,
  Fade,
  Modal,
  Typography,
} from '@mui/material';

// =================React Hook==================
import { useDispatch, useSelector } from 'react-redux';

// =================Actions==================
import { setFileNoData } from '../../actions/menuButton';

function ModalFileNoData() {
// ==================HOOK=========================
  const dispatch = useDispatch();
  const fileNoData = useSelector((state) => state.menuButton.fileNoData);
  // ==================handler=========================
  const handleCloseFileNoDataModal = () => {
    dispatch(setFileNoData(false));
  };

  return (
    <Modal
      open={fileNoData}
      onClose={handleCloseFileNoDataModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 600,
        },
      }}
    >
      <Fade in={fileNoData}>
        <Box className="commandLineClient--modal">
          <Typography id="modal-modal-title" variant="h4" component="h2">
            No data available
          </Typography>
          <Box className="commandLineClient--modal__text">
            <p>
              No data available for this selection, please select at least one file in the table
            </p>
            <div className="commandLineClient--modal__text--button">
              <button className="commandLineClient--modal__text--button__close" type="button" onClick={handleCloseFileNoDataModal}>Close</button>
            </div>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}

export default ModalFileNoData;
